import { render } from "./MainPageLayout.vue?vue&type=template&id=e3e07050"
import script from "./MainPageLayout.vue?vue&type=script&lang=js"
export * from "./MainPageLayout.vue?vue&type=script&lang=js"

import exportComponent from "D:\\Programming\\dashboard\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__